/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import StringResources from './nls/StringResources';
import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import SlotEditorFilterItem from './SlotEditorFilterItem';
import DndSlotFilterItemHandler from './DndSlotFilterItemHandler';
import SlotItemPlaceholder from './SlotItemPlaceholder';
import filter16 from '@ba/ba-graphics/dist/icons-js/filter_16';

import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes }  from 'mobx-react';
import '../stylesheets/slotEditor.scss';

const _ = require('underscore');  //TODO: should try to remove this dependency


/**
 * The SlotEditorLocalFiltersArea component is responsible for rendering a list of local filters.
 * It also manages drag and drop of items or data to the local filters area.
 */
class SlotEditorLocalFilters extends Component {

	constructor(props) {
		super(props);
	}

	componentWillUnmount(){
		this.dropFilterItemHandler && this.dropFilterItemHandler.destroy();
	}

	/**
	 * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
	 * @param slotAPIs - the slots to render
	 * @param pLayerId - (optional) the layerId to render
	 */
	render() {
		return this._renderLocalFiltersArea(this.props.localFiltersInfo);
	}

	/**
	 * Render the local filters area.
	 **/
	_renderLocalFiltersArea(localFiltersInfo) {
		return (
			<div className="slotEditor__localFilters"
				ref={(node) => { this.domNode = node; }}
				tabIndex="0"
				onKeyUp= { (event) => this.props.a11Y.filterHeaderHandleKeyUp(event, this.domNode, this.dropFilterItemHandler, this.props.filterItemActionHandler) }
				aria-label={StringResources.get('localFilters')}
			>
				<div className="slotEditor__localFilters__heading__container">
					<div className="slotEditor__localFilters__heading__icon">
						<SVGIcon iconId={filter16.id} size="small" />
					</div>
					{StringResources.get('localFilters')}
				</div>
				<div className="slotEditor__localFilters__attachPoint"></div>
				{this._renderLocalFilters(localFiltersInfo)}
				<SlotItemPlaceholder
					a11Y={this.props.a11Y}
					slotDataItemHandler={this.props.filterItemActionHandler}
					dashboardApi={this.props.dashboardApi}
					initializeDnd={this._initializeDndSupport.bind(this)}
					parentNode ={this.domNode}
				/>
			</div>
		);
	}

	_renderLocalFilters(localFiltersInfo) {
		const items = _.map(localFiltersInfo, (localFilterInfo, idx) => {
			const itemName = localFilterInfo.isMissing ? StringResources.get('missingColumn', {
				columnLabel: localFilterInfo.columnId
			}) : localFilterInfo.name;
			return (
				<div className="slotEditor__localFilters__item"  key={'localFilters' + idx}>
					<SlotEditorFilterItem
						itemName={itemName}
						filterString={localFilterInfo.filterString}
						numberOfFilterItems={localFilterInfo.numberOfFilterItems}
						itemColumnId={localFilterInfo.columnId}
						metadataColumn={localFilterInfo.metadataColumn}
						itemFilterId={localFilterInfo.id}
						filterItemActionHandler={this.props.filterItemActionHandler}
						a11Y={this.props.a11Y}
						dndManager={this.props.dndManager}
						dashboardApi={this.props.dashboardApi}
					/>
				</div>
			);
		});

		if (items.length) {
			return (
				<div className="slotEditor__localFilters__items">
					{items}
				</div>
			);
		}
	}

	//DRAG AND DROP SUPPORT....

	/** initializes drag and drop support for local filters (slotItemPlaceholder in localFilters section)
	 * @param dropTargetNode - domNode that dropzone will be initialized on
	 * @desc - 	The local filters drop target is a bit different than other items.  The dropTarget is a
	 *			placeholde under the local filters section.  The filterEditorNode is the point where the filter UI will be shown.
	 */
	_initializeDndSupport(dropTargetNode) {
		//A filter can be a drop target but not a dragdrop source.
		this.props.dndManager.then(
			(dndManager) => {
				if (dropTargetNode) {
					this.dropFilterItemHandler = new DndSlotFilterItemHandler({
						domNode: dropTargetNode,
						className: 'dndHover',

						slotDataItemHandler: this.props.filterItemActionHandler,
						addAfter: false,
						filterEditorNode: this.domNode,	//The node where the filter editor will be presented.
						dndManager: dndManager
					});
				}
			}
		);
	}
}

SlotEditorLocalFilters.propTypes = {
	dndManager: PropTypes.object.isRequired,
	localFiltersInfo: MobxPropTypes.observableArray,
	filterItemActionHandler: PropTypes.object,
	a11Y: PropTypes.object.isRequired,
	dashboardApi: PropTypes.object.isRequired
};

export default SlotEditorLocalFilters;



// WEBPACK FOOTER //
// ./src/js/SlotEditorLocalFilters.js